module.exports = __webpack_public_path__ + "img/is.0a541466.svg";